export default __webpack_public_path__ + "static/media/logoYounicam.5c949187.png";